import Cookies from "js-cookie";
import axios from "./config";
import qs from "qs";
import { jwtDecode } from "jwt-decode";
import { getHeader, getUserInfo } from '../../../utility/index';
interface DecodedToken {
  emp_id: string;
}


export const getAllTerritory = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = "";
  if (params.search)
    url = `/admin/territory-mappings?page=${page}&size=${size}&emp_id_search=${params.search}`;
  else url = `/admin/territory-mappings?page=${page}&size=${size}`;

  const response = await axios.post<any>(
    url,
    {}, // no body content
    {
      headers: getHeader(),
    }
  );

  return response.data;
};


export const getDropdowns = async (

): Promise<any> => {
  let url = "";

    url = `/admin/territory-identifiers`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const addNewTerritory = async (formData: any): Promise<any> => {
  let url = `/admin/territory-mappings/create`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};
export const updateTeri = async (
  formData: any,
  id: string
): Promise<any> => {
  const url = `/admin/territory-mappings/${id}`;

  const cleanedPayload = Object.fromEntries(
    Object.entries(formData).filter(([_, v]) => v !== undefined)
  );
  

  const response = await axios.put(url, cleanedPayload, {
    headers: {
      ...getHeader(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};


export const updateMonthly = async (
  formData: any,
  id: string
): Promise<any> => {
  const url = `/admin/employee-monthly-targets/${id}`;

  const cleanedPayload = Object.fromEntries(
    Object.entries(formData).filter(([_, v]) => v !== undefined)
  );

  const response = await axios.put(url, qs.stringify(cleanedPayload), {
    headers: {
      ...getHeader(),
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return response.data;
};
export const getSpecificTeri = async (
  id: string,
): Promise<any> => {
  let url = `admin/territory-mappings/${id}`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
export const getSpecificMon = async (
  id: string,
): Promise<any> => {
  let url = `admin/employee-monthly-targets/${id}`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
export const deleteTerritory = async (id: number): Promise<any> => {
  let url = `/admin/territory-mappings/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const notificationSEND = async (formData: any): Promise<any> => {
  let url = `/admin/send_notification`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};
